import React, { useState } from 'react';

const API = 'http://localhost:8000/api/v1';

function Counterparty() {
  const [searchType, setSearchType] = useState('inn');
  const [searchValue, setSearchValue] = useState('');
  const [result, setResult] = useState(null);
  const [checking, setChecking] = useState(false);
  const [history, setHistory] = useState(() => {
    const saved = localStorage.getItem('khepri_counterparty_history');
    return saved ? JSON.parse(saved) : [];
  });
  const [favorites, setFavorites] = useState(() => {
    const saved = localStorage.getItem('khepri_counterparty_favorites');
    return saved ? JSON.parse(saved) : [];
  });

  const check = async (e) => {
    e.preventDefault();
    if (!searchValue.trim() || checking) return;

    setChecking(true);
    setResult(null);

    await new Promise(resolve => setTimeout(resolve, 800));

    let data;
    if (searchType === 'inn') {
      try {
        const res = await fetch(API + '/tax/check_counterparty?inn=' + searchValue);
        data = await res.json();
      } catch (err) {
        data = {
          inn: searchValue,
          status: 'high',
          risks: [{ severity: 'high', description: 'Не удалось получить данные. Попробуйте позже.' }],
        };
      }
    } else {
      const statuses = ['ok', 'high', 'critical'];
      const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];
      data = {
        inn: 'ИНН не найден',
        name: searchValue,
        status: randomStatus,
        risks: [
          { severity: randomStatus === 'ok' ? 'low' : randomStatus === 'high' ? 'high' : 'critical', description: 'Компания найдена по названию (демо-режим)' },
        ],
      };
    }

    setResult(data);
    setChecking(false);

    const newRecord = {
      inn: data.inn || searchValue,
      name: data.name || '',
      status: data.status,
      date: new Date().toLocaleString('ru-RU'),
    };
    const updated = [newRecord, ...history.filter(h => h.inn !== newRecord.inn)].slice(0, 20);
    setHistory(updated);
    localStorage.setItem('khepri_counterparty_history', JSON.stringify(updated));
  };

  const clearHistory = () => {
    setHistory([]);
    localStorage.removeItem('khepri_counterparty_history');
  };

  const toggleFavorite = (id) => {
    setFavorites(prev => {
      const exists = prev.includes(id);
      const updated = exists ? prev.filter(f => f !== id) : [...prev, id];
      localStorage.setItem('khepri_counterparty_favorites', JSON.stringify(updated));
      return updated;
    });
  };

  const downloadReport = () => {
    if (!result) return;
    const report = `ОТЧЁТ О ПРОВЕРКЕ КОНТРАГЕНТА
Дата: ${new Date().toLocaleString('ru-RU')}

ИНН: ${result.inn || 'Не указан'}
Название: ${result.name || 'Не указано'}
Статус: ${getStatusText(result.status)}

Риски:
${(result.risks || []).map(r => `- [${r.severity}] ${r.description}`).join('\n') || 'Рисков не обнаружено'}

Отчёт сгенерирован Khepri
`;
    const blob = new Blob([report], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Отчёт_${result.inn || result.name || 'контрагент'}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const exportHistoryCSV = () => {
    if (history.length === 0) return;
    const rows = [
      ['ИНН/Название', 'Статус', 'Дата проверки', 'Избранное'],
      ...history.map(h => [h.name || h.inn, getStatusText(h.status), h.date, isFavorite(h.inn || h.name) ? 'Да' : 'Нет']),
    ];
    const csv = rows.map(r => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'История_проверок_Khepri.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const getStatusIcon = (status) => {
    if (status === 'critical') return '🔴';
    if (status === 'high') return '🟡';
    return '🟢';
  };

  const isFavorite = (id) => favorites.includes(id);

  const getStatusColor = (status) => {
    if (status === 'critical') return '#EF4444';
    if (status === 'high') return '#F59E0B';
    return '#10B981';
  };

  const getStatusText = (status) => {
    if (status === 'critical') return 'Критический';
    if (status === 'high') return 'Высокий';
    return 'Нормальный';
  };

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>🔍 Проверка контрагента</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 12 }}>
        Проверьте контрагента по ИНН или названию компании
      </p>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <button
          type="button"
          onClick={() => { setSearchType('inn'); setSearchValue(''); setResult(null); }}
          style={{
            padding: '8px 16px',
            background: searchType === 'inn' ? '#F7DE8A' : '#1E293B',
            color: searchType === 'inn' ? '#0F172A' : '#94A3B8',
            border: '1px solid #8A6636',
            borderRadius: 20,
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: searchType === 'inn' ? 700 : 500,
          }}
        >
          По ИНН
        </button>
        <button
          type="button"
          onClick={() => { setSearchType('name'); setSearchValue(''); setResult(null); }}
          style={{
            padding: '8px 16px',
            background: searchType === 'name' ? '#F7DE8A' : '#1E293B',
            color: searchType === 'name' ? '#0F172A' : '#94A3B8',
            border: '1px solid #8A6636',
            borderRadius: 20,
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: searchType === 'name' ? 700 : 500,
          }}
        >
          По названию
        </button>
      </div>

      <form onSubmit={check} style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <input
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
          placeholder={searchType === 'inn' ? 'ИНН (10 цифр)' : 'Название компании'}
          style={{ flex: 1, padding: 10, background: '#0F172A', border: '1px solid #8A6636', borderRadius: 8, color: '#F8FAFC' }}
          disabled={checking}
        />
        <button type="submit" style={{ padding: '10px 20px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: checking ? 'default' : 'pointer', fontWeight: 700, opacity: checking ? 0.6 : 1 }} disabled={checking}>
          {checking ? '⏳ Проверяем...' : 'Проверить'}
        </button>
      </form>

      {checking && (
        <div style={{ marginTop: 16, padding: 16, background: '#1E293B', borderRadius: 8, border: '1px solid #8A6636', textAlign: 'center' }}>
          <p style={{ color: '#94A3B8' }}>Проверяем контрагента...</p>
        </div>
      )}

      {result && !checking && (
        <div style={{ marginTop: 16, padding: 16, background: '#1E293B', borderRadius: 8, border: '1px solid #8A6636', animation: 'fadeIn 0.3s' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8, flexWrap: 'wrap', gap: 10 }}>
            <div>
              {result.inn && result.inn !== 'ИНН не найден' && <p>ИНН: {result.inn}</p>}
              {result.name && <p>Название: {result.name}</p>}
              <p>Статус: {getStatusIcon(result.status)} <span style={{ color: getStatusColor(result.status), fontWeight: 600 }}>{getStatusText(result.status)}</span></p>
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button
                onClick={() => toggleFavorite(result.inn || result.name)}
                style={{
                  padding: '8px 16px',
                  background: isFavorite(result.inn || result.name) ? '#F59E0B' : '#8A6636',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: 13,
                }}
              >
                {isFavorite(result.inn || result.name) ? '★ В избранном' : '☆ В избранное'}
              </button>
              <button
                onClick={downloadReport}
                style={{
                  padding: '8px 16px',
                  background: '#F7DE8A',
                  color: '#0F172A',
                  border: 'none',
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: 13,
                }}
              >
                📥 Скачать отчёт
              </button>
            </div>
          </div>
          {(result.risks || []).map((r, i) => <p key={i} style={{ color: '#F59E0B' }}>[{r.severity}] {r.description}</p>)}
        </div>
      )}

      {favorites.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <h3 style={{ color: '#F7DE8A' }}>⭐ Избранные контрагенты</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 10 }}>
            {favorites.map((fav, i) => (
              <div key={i} style={{ padding: '8px 16px', background: '#1E293B', border: '1px solid #F59E0B', borderRadius: 20, cursor: 'pointer' }} onClick={() => setSearchValue(fav)}>
                <span style={{ color: '#F59E0B', marginRight: 6 }}>★</span>
                <span style={{ fontSize: 13 }}>{fav}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {history.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
            <h3 style={{ color: '#F7DE8A' }}>📋 История проверок ({history.length})</h3>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={exportHistoryCSV} style={{ background: 'none', border: '1px solid #8A6636', color: '#94A3B8', cursor: 'pointer', fontSize: 12, padding: '4px 8px', borderRadius: 4 }}>
                📥 CSV
              </button>
              <button onClick={clearHistory} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' }}>
                Очистить
              </button>
            </div>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
                <th style={{ padding: 8 }}>ИНН / Название</th>
                <th style={{ padding: 8 }}>Статус</th>
                <th style={{ padding: 8 }}>Дата проверки</th>
                <th style={{ padding: 8 }}>Избранное</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #8A6636', cursor: 'pointer' }} onClick={() => setSearchValue(h.inn)}>
                  <td style={{ padding: 8 }}>{h.name || h.inn}</td>
                  <td style={{ padding: 8 }}>
                    {getStatusIcon(h.status)} <span style={{ color: getStatusColor(h.status), fontWeight: 600 }}>{getStatusText(h.status)}</span>
                  </td>
                  <td style={{ padding: 8, color: '#94A3B8' }}>{h.date}</td>
                  <td style={{ padding: 8 }}>
                    <span style={{ color: isFavorite(h.inn || h.name) ? '#F59E0B' : '#94A3B8' }}>{isFavorite(h.inn || h.name) ? '★' : '☆'}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default Counterparty;